import { render, staticRenderFns } from "./client-update.vue?vue&type=template&id=2a4dd7db&"
import script from "./client-update.vue?vue&type=script&lang=js&"
export * from "./client-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports